<template>
  <b-modal
      :id="props.id"
      :title="title"
      size="lg"
      role="dialog"
      ref="modalRef"
      @ok="addTraineeToGroup"
      :ok-title="t('SAVE')"
      :cancel-title="t('CANCEL')"
  >
    <div>
      <b-form ref="formRef">
        <b-form-group
            label-for="add-trainee-reason"
            :label="t('REASON_REQUIRED_TO_ADD_TO_GROUP')"
            :state="reasonState"
            :invalid-feedback="t('ERRORS.REASON_IS_REQUIRED')"
        >
          <b-textarea id="add-trainee-reason" v-model="reason" class="form-control" required></b-textarea>
        </b-form-group>
      </b-form>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import {computed, inject, ref} from "vue";
import {useI18n} from "vue-i18n";

const axios = inject("axios");
const {t} = useI18n();

const title = ref("");
const groupId = ref("");
const accountId = ref("");
const reason = ref("");
const submitted = ref(false);

const modalRef = ref(null);
const formRef = ref(null);

const props = defineProps<{
  id: string;
  afterSave?: () => Promise<any>;
}>();

const openModal = (titleVal: string, groupIdVal: string, accountIdVal: string) => {
  title.value = titleVal;
  groupId.value = groupIdVal;
  accountId.value = accountIdVal;
  reason.value = "";
  submitted.value = false;
  modalRef.value.show(props.id);
};

const reasonState = computed(() => {
  return !submitted.value || (reason.value || "").trim().length > 0;
});

const addTraineeToGroup = async function (ev: Event) {
  ev.preventDefault();
  submitted.value = true;

  if (!formRef.value.checkValidity()) {
    return;
  }

  const requestParams = {
    accountId: accountId.value,
  };

  const requestData = {
    skipAvailabilityValidation: true,
    skipAvailabilityValidationReason: reason.value,
  };

  await axios.post(`/training/group/${groupId.value}/trainee`, requestData, {params: requestParams});

  if (props.afterSave) {
    await props.afterSave();
  }

  modalRef.value.hide(props.id);
};

defineExpose({
  openModal,
});
</script>

<style scoped lang="scss">

</style>
